import { render, staticRenderFns } from "./add-comp.vue?vue&type=template&id=eac6e96a"
import script from "./add-comp.vue?vue&type=script&lang=js"
export * from "./add-comp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eac6e96a')) {
      api.createRecord('eac6e96a', component.options)
    } else {
      api.reload('eac6e96a', component.options)
    }
    module.hot.accept("./add-comp.vue?vue&type=template&id=eac6e96a", function () {
      api.rerender('eac6e96a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/add-comp.vue"
export default component.exports